import { client } from '@/services/api/axios.ts';
import { useMutation } from '@tanstack/react-query';

export const usePostLogErrorToBackend = () => {
  return useMutation({
    mutationFn: async (error: Error) => {
      await client.post('/error-logging', {
        error: {
          message: error.message,
          stack: error.stack,
          name: error.name,
        },
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: window.location.href,
      });
    },
  });
};
